import { Pressable, Modal, View, Text } from 'react-native';
import Animated, { FadeIn, SlideInDown } from 'react-native-reanimated';
import { X } from 'lucide-react-native';
import { WaitlistForm } from '@/components/WaitlistForm';

const MODAL_COLORS = {
  dark: {
    bgOverlay: 'rgba(0,0,0,0.6)',
    bgModal: '#0f1f38',
    border: 'rgba(255,255,255,0.1)',
    teal: '#4fd1c5',
    white: '#FFFFFF',
    text3: 'rgba(255,255,255,0.38)',
  },
  light: {
    bgOverlay: 'rgba(0,0,0,0.35)',
    bgModal: '#ffffff',
    border: 'rgba(0,0,0,0.10)',
    teal: '#0d7d71',
    white: '#1d1d1f',
    text3: '#8e8e93',
  },
};

interface WaitlistModalProps {
  visible: boolean;
  onClose: () => void;
  colorScheme?: 'dark' | 'light';
}

export function WaitlistModal({ visible, onClose, colorScheme = 'dark' }: WaitlistModalProps) {
  const C = MODAL_COLORS[colorScheme];
  return (
    <Modal visible={visible} transparent animationType="none" onRequestClose={onClose}>
      <Animated.View
        entering={FadeIn.duration(200)}
        style={{ flex: 1, backgroundColor: C.bgOverlay, justifyContent: 'center', alignItems: 'center', padding: 20 }}
      >
        <Pressable style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} onPress={onClose} />

        <Animated.View
          entering={SlideInDown.duration(350).springify()}
          style={{
            width: '100%',
            maxWidth: 520,
            backgroundColor: C.bgModal,
            borderRadius: 20,
            borderWidth: 1,
            borderColor: C.border,
            padding: 32,
            gap: 20,
          }}
        >
          {/* Header */}
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <View>
              <Text style={{ color: C.white, fontSize: 22, fontWeight: '700' }}>
                Join the Waitlist
              </Text>
              <Text style={{ color: C.text3, fontSize: 13, marginTop: 4 }}>
                Invite-only early access. Refer friends to move up the list.
              </Text>
            </View>
            <Pressable onPress={onClose} style={{ padding: 4 }}>
              <X size={20} color={C.text3} />
            </Pressable>
          </View>

          {/* Waitlist form */}
          <WaitlistForm colorScheme={colorScheme} />
        </Animated.View>
      </Animated.View>
    </Modal>
  );
}
